import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// A single SPA serves three separately installable experiences.
// The initial profile is selected synchronously in index.html; this covers
// client-side navigation after the first page load.
export default function PwaRouteMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__setCulinexPwaProfile?.(pathname);
  }, [pathname]);
  return null;
}
